var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[[_c('div',{staticClass:"d-flex ml-12 mt-8"},[_c('v-btn',{on:{"click":_vm.voltar}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._v(" voltar ")],1)],1)],_c('Paciente')],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }